import React from "react";
import { Helmet } from "@dr.pogodin/react-helmet";
import { Link } from "react-router-dom";

export default function ThankYou() {
  return (
    <main className="mx-auto max-w-3xl px-4 md:px-6 py-8">
      <Helmet>
        <title>Thanks! | Free1099Calc</title>
        <meta name="robots" content="noindex" />
        <link rel="canonical" href="https://free1099calc.com/thank-you" />
      </Helmet>

      <section className="rounded-2xl border bg-white p-6 md:p-8">
        <h1 className="text-3xl font-bold">Thanks — your message was sent.</h1>
        <p className="mt-3 text-slate-700">
          We’ll get back to you soon. In the meantime, explore our tools:
        </p>
        <ul className="mt-4 list-disc pl-6 text-slate-700 space-y-1">
          <li><Link className="underline" to="/">Free 1099 Tax Calculator</Link></li>
          <li><Link className="underline" to="/retirement">Retirement Calculator</Link></li>
          <li><Link className="underline" to="/calculators/inflation">Inflation Calculator</Link></li>
          <li><Link className="underline" to="/blog">Blog</Link></li>
        </ul>
      </section>
    </main>
  );
}
